/* TODO: Stubbed out button, PinButton component button to be implemented */

import React, { useState, useEffect } from 'react';
import clsx from 'clsx';

import { BaseActionButtonProps } from '../BaseActionButtonProps';

import commonStyles from '../ActionButtonCommon.module.scss';
import styles from './FacebookButton.module.scss';
import CtaLink from 'components/helpers/Atoms/Cta/CtaLink';
import useDictionary from 'lib/hooks/useDictionary';
import { useContentItem } from 'lib/hooks/useContentItem';
interface FacebookButtonProps extends BaseActionButtonProps {
  isSubAction?: boolean;
}

export function FacebookButton({
  label,
  variant,
  isSubAction = false,
  toolbarIdentifier,
  eventPositionSuffix,
}: FacebookButtonProps): JSX.Element {
  const contentItem = useContentItem();

  const [pageUrl, setPageUrl] = useState(contentItem?.PageUrl || '');
  const { getDictionaryValue } = useDictionary();

  // Update with meta tag values on client side after hydration
  useEffect(() => {
    if (typeof document !== 'undefined') {
      const ogUrl = document.querySelector('meta[property="og:url"]')?.getAttribute('content');
      if (ogUrl) {
        setPageUrl(ogUrl);
      } else if (!contentItem?.PageUrl && typeof window !== 'undefined') {
        setPageUrl(window.location.href);
      }
    }
  }, [contentItem?.PageUrl]);
  // Create Facebook share link
  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}&ref=share`;
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    // Open Facebook in popup window
    if (typeof window !== 'undefined') {
      const popupFeatures = `width=${900},height=${900},toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes`;
      window.open(facebookUrl, '_blank', popupFeatures);
    }
  };

  const getGtmPosition = (): string => {
    return [toolbarIdentifier, eventPositionSuffix].filter(Boolean).join('.') || '';
  };

  const gtmEvent = {
    social_network: 'Facebook',
    event: 'social_share',
    position: getGtmPosition(),
  };

  return (
    <div
      className={clsx({
        [commonStyles['actionButtonWrapper--horizontal']]: variant === 'horizontal',
      })}
    >
      <CtaLink
        ctaStyle={variant === 'horizontal' && !isSubAction ? 'link-invert-underline' : 'none'}
        ctaVariant="brand"
        url={facebookUrl}
        suppressNewTabIcon
        className={clsx(
          commonStyles.actionButtonBase,
          commonStyles[`actionButton--${variant}`],
          isSubAction && commonStyles['actionButtonSubAction']
        )}
        aria-label={`${label}, ${getDictionaryValue('Common.OpensInNewWindow', '(Opens in a new window)')}`}
        onClick={handleClick}
        ctaIconBefore="facebook"
        ctaIconSize="sm"
        ctaIconNoSpacer={variant === 'vertical'}
        ctaIconClassName={styles.icon}
        gtmEvent={gtmEvent}
      >
        {label}
      </CtaLink>
    </div>
  );
}
